module.exports = __webpack_public_path__ + "static/img/6.7aa7e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/6.png
// module id = 0O0W
// module chunks = 0